"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _EllipsisDropdown = _interopRequireDefault(require("../../../../../components/shared-components/EllipsisDropdown"));

var _Flex = _interopRequireDefault(require("../../../../../components/shared-components/Flex"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _icons = require("@ant-design/icons");

var _moreTableData = _interopRequireDefault(require("./moreTableData"));

var _form = _interopRequireDefault(require("./form"));

var _reactCsv = require("react-csv");

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

//import { useHistory } from 'react-router';
var Option = _antd.Select.Option;
var allTokens = [];
var date = new Date();
var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
var header = [{
  label: "RM_code",
  key: "RM_code"
}, {
  label: "Student_Name",
  key: "Student_Name"
}, {
  label: "Token_Number",
  key: "Token_Number"
}, {
  label: "Date",
  key: "Date"
}, {
  label: "Reason",
  key: "Reason"
}, {
  label: "WhatsApp_Number",
  key: "WhatsApp_Number"
}, {
  label: "Calling_Number",
  key: "Calling_Number"
}];

var TableData = function TableData(_ref) {
  var data = _ref.data;
  // const cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // const history = useHistory();
  // eslint-disable-next-line

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1]; // const [tableData,setTableData] = useState(data);
  // const [tableData, setTableData] = useState(data);


  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      dropStatus = _useState6[0],
      setDropStatus = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      dropReason = _useState8[0],
      setDropReason = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      formDetail = _useState10[0],
      setFormDetail = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      isFormVisible = _useState12[0],
      setIsFormVisible = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      formType = _useState14[0],
      setFormType = _useState14[1];

  var csvRport = {
    filename: "\"DropOutRequest Data\" + \" \" + ".concat(today, " + \" \" + ").concat(time),
    headers: header,
    data: data
  }; // useEffect(async () => {
  //   setTableData(data);
  // }, [data]);
  // useEffect(() => {
  //   async function fetchData() {
  //     setTableData(data);
  //   }
  //   fetchData();
  // }, [data]);

  var tableColumns = [{
    title: "Token No",
    dataIndex: 'Token_Number',
    key: 'Token_Number',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Token_Number');
    }
  }, {
    title: "RM Code",
    dataIndex: 'RM_Code',
    key: 'RM_Code',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_Code');
    }
  }, {
    title: "Request Date",
    dataIndex: 'Date',
    key: "Request Date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Date');
    }
  }, {
    title: "RM's Reason",
    dataIndex: 'Reason',
    key: "Reason",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Reason');
    },
    render: function render(_, record) {
      return record.Reason ? record.Reason : "No Reason";
    }
  }, {
    title: "Whatsapp Number",
    dataIndex: 'WhatsApp_Number',
    key: 'WhatsApp_Number',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'WhatsApp_Number');
    }
  }, {
    title: 'Action',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, elm) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EllipsisDropdown.default, {
        menu: dropdownMenu(elm)
      }));
    }
  }, {
    title: 'check',
    dataIndex: 'RM_code',
    fixed: "left",
    render: function render(_, elm) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
        onClick: function onClick() {
          return getData(elm);
        }
      }));
    }
  }];

  var onDropClick = function onDropClick(value, str) {
    setFormDetail(value);
    setIsFormVisible(true);
    setFormType(str);
  };

  var getData = function getData(elm) {
    if (allTokens.includes(elm)) {
      allTokens.splice(allTokens.indexOf(elm), 1);
    } else {
      allTokens.push(elm);
    }

    console.log(allTokens);

    if (allTokens.length !== 0) {
      document.getElementById("edit_bulk").style.display = "block";
    } else {
      document.getElementById("edit_bulk").style.display = "none";
    }
  };

  var handleCancel = function handleCancel() {
    setVisible(false);
    setDropStatus("");
    setDropReason("");
  };

  var showModal = function showModal() {
    setVisible(true);
  };

  var handleOk = function handleOk() {
    var data = {
      "dropStatus": dropStatus,
      "dropReason": dropReason,
      "allData": allTokens
    };
    console.log(data);
    var url = _config.default.updateBulkStudentdropreq;

    _axios.default.post(url, data, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);
      alert("Updated Successfully");
      window.location = '/clPortal/app/parent/requests';
    }, function (err) {
      var obj = {
        "status": "error",
        "message": "Network Error"
      };
      if (err.response) setapiError(err.response);else setapiError(obj);
    });
  };

  var handleBulkEditMainSelect = function handleBulkEditMainSelect(value) {
    setDropStatus(value);

    if (value === 'हाँ') {
      setDropReason("");
    }
  };

  var dropdownMenu = function dropdownMenu(elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return onDropClick(elm, "DontDrop");
      },
      style: {
        color: 'green'
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.PlusCircleOutlined, {
      style: {
        color: 'green'
      },
      className: "mr-1"
    }), "Don't Drop"))), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return onDropClick(elm, "Drop");
      },
      style: {
        color: 'red'
      }
    }, " ", /*#__PURE__*/_react.default.createElement(_icons.MinusCircleOutlined, {
      style: {
        color: 'red'
      },
      className: "mr-1"
    }), "Drop"))));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isFormVisible ? /*#__PURE__*/_react.default.createElement(_form.default, {
    formDetail: formDetail,
    formType: formType,
    isFormVisible: isFormVisible,
    onOk: function onOk() {
      return setIsFormVisible(true);
    },
    onCancel: function onCancel() {
      return setIsFormVisible(false);
    }
  }) : null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Drop Out Requests",
    style: {
      'fontSize': '5px'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    className: "Edit-open",
    type: "primary",
    onClick: function onClick() {
      return showModal();
    },
    id: "edit_bulk",
    style: {
      display: "none"
    }
  }, "Edit"), /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: tableColumns,
    dataSource: data,
    rowKey: "index",
    expandable: {
      expandedRowRender: function expandedRowRender(record) {
        return /*#__PURE__*/_react.default.createElement(_moreTableData.default, {
          record: record
        });
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Edit Here",
    visible: visible,
    onOk: function onOk() {
      return handleOk();
    },
    onCancel: function onCancel() {
      return handleCancel();
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    onChange: handleBulkEditMainSelect,
    style: {
      width: 200
    },
    placeholder: "Select option"
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "\u0939\u093E\u0901"
  }, "Drop"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "\u0928\u0939\u0940\u0902"
  }, "Don't Drop")), dropStatus === 'हाँ' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
    name: "radiogroup",
    onChange: function onChange(e) {
      setDropReason(e.target.value);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092B\u093E\u092F\u0926\u093E \u0928\u0939\u0940\u0902 \u0926\u093F\u0916 \u0930\u0939\u093E \u0939\u0948"
  }, " \u092B\u093E\u092F\u0926\u093E \u0928\u0939\u0940\u0902 \u0926\u093F\u0916 \u0930\u0939\u093E \u0939\u0948"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092C\u091A\u094D\u091A\u0947 \u0915\u094B \u092A\u0938\u0902\u0926 \u0928\u0939\u0940 \u0906\u092F\u093E"
  }, "\u092C\u091A\u094D\u091A\u0947 \u0915\u094B \u092A\u0938\u0902\u0926 \u0928\u0939\u0940 \u0906\u092F\u093E"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092C\u091A\u094D\u091A\u0947 \u092F\u093E \u092E\u093E\u0901 \u0915\u0947 \u092A\u093E\u0938 \u0938\u092E\u092F \u0928\u0939\u0940\u0902 \u0939\u0948"
  }, "\u092C\u091A\u094D\u091A\u0947 \u092F\u093E \u092E\u093E\u0901 \u0915\u0947 \u092A\u093E\u0938 \u0938\u092E\u092F \u0928\u0939\u0940\u0902 \u0939\u0948"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0918\u0930 \u092C\u0926\u0932 \u0930\u0939\u093E \u0939\u0948, \u0935\u0939\u093E \u0938\u0941\u0935\u093F\u0927\u093E \u0928\u0939\u0940\u0902 \u0939\u0948"
  }, "\u0918\u0930 \u092C\u0926\u0932 \u0930\u0939\u093E \u0939\u0948, \u0935\u0939\u093E \u0938\u0941\u0935\u093F\u0927\u093E \u0928\u0939\u0940\u0902 \u0939\u0948"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "RM \u0915\u0947 \u091B\u094B\u0921\u093C\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u092C\u091A\u094D\u091A\u093E \u0921\u094D\u0930\u0949\u092A \u0939\u094B \u0917\u092F\u093E \u0939\u0948"
  }, "RM \u0915\u0947 \u091B\u094B\u0921\u093C\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u092C\u091A\u094D\u091A\u093E \u0921\u094D\u0930\u0949\u092A \u0939\u094B \u0917\u092F\u093E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0921\u0941\u092A\u094D\u0932\u093F\u0915\u0947\u091F"
  }, "\u0921\u0941\u092A\u094D\u0932\u093F\u0915\u0947\u091F"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092B\u094B\u0928 \u0959\u0930\u093E\u092C \u0939\u0948/\u092B\u094B\u0928 \u092E\u0947\u0902 \u0930\u093F\u091A\u093E\u0930\u094D\u091C \u0928\u0939\u0940\u0902 \u0939\u0948 "
  }, "\u092B\u094B\u0928 \u0959\u0930\u093E\u092C \u0939\u0948/\u092B\u094B\u0928 \u092E\u0947\u0902 \u0930\u093F\u091A\u093E\u0930\u094D\u091C \u0928\u0939\u0940\u0902 \u0939\u0948 \u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0938\u093E\u0930\u0940 \u0935\u0930\u094D\u0915\u0936\u0940\u091F \u0915\u092E\u094D\u092A\u0932\u0940\u091F \u0939\u094B \u0917\u0908 \u0939\u0948"
  }, "\u0938\u093E\u0930\u0940 \u0935\u0930\u094D\u0915\u0936\u0940\u091F \u0915\u092E\u094D\u092A\u0932\u0940\u091F \u0939\u094B \u0917\u0908 \u0939\u0948\u0964")))) : null)));
};

var _default = TableData;
exports.default = _default;